import { render, staticRenderFns } from "./ModeratorsConfig.vue?vue&type=template&id=26ca2783&"
import script from "./ModeratorsConfig.vue?vue&type=script&lang=js&"
export * from "./ModeratorsConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports